export const COMMON_EVENT_NAMES = {
  NAVIGATED: "Navigation Link Clicked",
  SITE_CLICK: "Site Click",
  PAGE_VIEWED: "PAGE VIEWED"
};

export const XSELL_PREFIX = "FDR XS";

export const FDR_PAGE_CONFIG = [
  { page: "promo_offer", urlReg: /\/?promo=(?!s\b)/ },
  { page: "promotions", urlReg: /(\/\w+)?#promos/ },
  { page: "track_information", urlReg: /^\/racetracks((?!race=).)*$/ },
  { page: "program_page", urlReg: /\/racetracks/ },
  { page: "program_page", urlReg: /\/live\/TVG\d?\/.*\?race=.+/ }
];
